// extracted by mini-css-extract-plugin
export default {"root":"UnavailablePersonalAccount_root__U5spM","text":"UnavailablePersonalAccount_text__61EaD","addNewAccountButton":"UnavailablePersonalAccount_addNewAccountButton__FiZyT"};